import axios from "axios";
import Swal from "sweetalert2";
import api from "./api_refresh_token";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

export const baseURL = "https://apicmms.rochasystem.com.br/api"; // a url para acessar a api

// busca token de usuario ja autenticado
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

// Fazer login por token
export const createSession = (email, password) =>
  axios
    .post(
      // metodo da requisição
      `${baseURL}/login`,
      {
        // url base + rota de busca
        email, // parametros se necessario
        password,
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Usuário ou senha incorretos!",
      });
    })
    .then(function (response) {
      return response;
    });

// Busca empresas

export const getEmpresas = () =>
  api
    .get(`${baseURL}/empresas`, {
      headers: {
        // se a requisição exigir um token, deve ser passado a authorization no header
        Authorization: `Bearer ${getToken()}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Usuário ou senha incorretos!",
      });
    })
    .then(function (response) {
      return response;
    });
